<div class="container accent" *ngIf="showProgress">
    <marquee class="text">கலந்தாய்வு நடைபெற்றுக்கொண்டிருக்கின்றது...</marquee>
    <div class="btn-div">
        <button mat-raised-button (click)="kalanthaivu()" class="green-600">கலந்தாய்வு முடிக்க</button>
    </div>
</div>